import { create } from 'zustand'
import { BotState, GridLevel, Position, Order, BotStats } from '@/types'

interface BotStoreState {
  // Estado del bot
  botState: BotState | null
  isLoading: boolean
  error: string | null
  
  // Grid data
  gridLevels: GridLevel[]
  positions: Position[]
  orders: Order[]
  
  // Estadísticas
  stats: BotStats | null
  
  // Precio actual
  currentPrice: number | null
  
  // Auto-refresh
  autoRefresh: boolean
  refreshInterval: number
}

interface BotStoreActions {
  setBotState: (state: BotState) => void
  setGridLevels: (levels: GridLevel[]) => void
  setPositions: (positions: Position[]) => void
  setOrders: (orders: Order[]) => void
  setStats: (stats: BotStats) => void
  setCurrentPrice: (price: number) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  clearError: () => void
  toggleAutoRefresh: () => void
  setRefreshInterval: (interval: number) => void
  reset: () => void
}

export const useBotStore = create<BotStoreState & BotStoreActions>((set) => ({
  // Estado inicial
  botState: null,
  isLoading: false,
  error: null,
  gridLevels: [],
  positions: [],
  orders: [],
  stats: null,
  currentPrice: null,
  autoRefresh: true,
  refreshInterval: 5000, // 5 segundos

  // Acciones
  setBotState: (state) => set({ botState: state }),
  setGridLevels: (levels) => set({ gridLevels: levels }),
  setPositions: (positions) => set({ positions }),
  setOrders: (orders) => set({ orders }),
  setStats: (stats) => set({ stats }),
  setCurrentPrice: (price) => set({ currentPrice: price }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),
  toggleAutoRefresh: () => set((state) => ({ autoRefresh: !state.autoRefresh })),
  setRefreshInterval: (interval) => set({ refreshInterval: interval }),
  reset: () => set({
    botState: null,
    gridLevels: [],
    positions: [],
    orders: [],
    stats: null,
    currentPrice: null,
    error: null,
    isLoading: false
  })
}))